import { render, staticRenderFns } from "./custom-completion-screen.vue?vue&type=template&id=23e43dc4&scoped=true&"
import script from "./custom-completion-screen.vue?vue&type=script&lang=js&"
export * from "./custom-completion-screen.vue?vue&type=script&lang=js&"
import style0 from "./custom-completion-screen.vue?vue&type=style&index=0&id=23e43dc4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e43dc4",
  null
  
)

component.options.__file = "custom-completion-screen.vue"
export default component.exports